import { schema } from 'normalizr';

import { SCHEMA_TYPE_QUARNTINE } from '../constants/schemaTypes';

import userSchema from './user';
import credentialSchema from './credential';

const quarantineSchema = new schema.Entity(SCHEMA_TYPE_QUARNTINE, {
  owner: userSchema,
  data_credentials: credentialSchema,
});

export default quarantineSchema;
